<button
  class="account-dropdown"
  #accountPopover="ngbPopover"
  [ngbPopover]="personalMenuTemplate"
  [triggers]="'manual'"
  [autoClose]="'outside'"
  [animation]="false"
  [popperOptions]="popperOptions"
  [popoverClass]="
    showingBreadcrumbs
      ? 'account-dropdown__popover account-dropdown__popover--with-breadcrumbs'
      : 'account-dropdown__popover'
  "
  [placement]="'bottom-end'"
  (click)="accountPopover.toggle()"
  ftrButton
  #personalMenuPopOver="ngbPopover"
  color="grey"
  [autoWidth]="true"
  [attr.aria-label]="personalMenuText"
>
  <ftr-user-avatar size="ExtraLarge" [user]="(user$ | async) ?? undefined" />
  <ftr-icon align="Middle" [icon]="accountPopover.isOpen() ? 'ChevronUp' : 'ChevronDown'" />
</button>

<ng-template #personalMenuTemplate>
  <ftr-personal-menu
    [currentCourtSystemId]="currentCourtSystemId"
    [ftrLogoPath]="ftrLogoPath"
    (focusin)="onFocusIn()"
    (focusout)="onFocusOut()"
  />
</ng-template>
